<div *ngIf="isLoggedIn" class="menu-container" [class.open]="isOpen">
  <div class="menu-header">
    <h2>Menu</h2>
    <div class="menu-header-actions">
      <button class="close-button" (click)="closeMenu()">
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>

  <div class="menu-content">
    <div class="section">
      <div class="expansion-panel" [class.expanded]="isProfileExpanded">
        <button class="expansion-header" (click)="toggleProfile()">
          <i class="material-icons expand-icon">{{isProfileExpanded ? 'expand_less' : 'expand_more'}}</i>
          <div class="header-content">
            <div class="header-text">
              <span class="header-title">Account</span>
            </div>
            <div class="user-profile">
              <app-user-profile-avatar [user]="user" />
            </div>
          </div>
        </button>
        <div class="expansion-content">
          <div class="menu-items">
            <a class="menu-item" routerLink="account" (click)="closeMenu()">
              <i class="material-icons">person</i>
              <span>Profile</span>
            </a>
            <a class="menu-item" routerLink="changepassword" (click)="closeMenu()">
              <i class="material-icons">lock</i>
              <span>Change Password</span>
            </a>
            <a class="menu-item" routerLink="/user/messages" (click)="closeMenu()">
              <i class="material-icons">chat</i>
              <span>Messages</span>
              <span class="menu-badge" *ngIf="unreadMessagesCount > 0">{{unreadMessagesCount}}</span>
            </a>
            <a class="menu-item" routerLink="/admin" (click)="closeMenu()" *ngIf="isAdmin()" [ngClass]="{'container': !isAdminPage()}">
              <i class="material-icons">admin_panel_settings</i>
              <span>Admin Panel</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <h3>Quick Access</h3>
      <div class="bento-grid">
        <a class="bento-card large bom-card extra-large" routerLink="/user" (click)="closeMenu()">
          <div class="card-background">
            <div *ngFor="let img of clientImages; let i = index"
                 class="slide"
                 [ngClass]="{'active': currentSlide === i}"
                 [ngStyle]="{'background-image': 'url(' + img + ')'}">
            </div>
          </div>
          <i class="material-icons card-icon">view_in_ar</i>
          <div class="card-content">
            <h4>BOM Models</h4>
            <p>Access and manage your bill of materials</p>
          </div>
        </a>
        <a class="bento-card" routerLink="/user/comparison" (click)="closeMenu()">
          <i class="material-icons card-icon">compare</i>
          <div class="card-content">
            <h4>Comparison</h4>
            <p>Compare BOM models</p>
          </div>
        </a>
        <a class="bento-card"
           [routerLink]="hasUserManagementAccess() ? '/user/management' : null"
           (click)="hasUserManagementAccess() ? closeMenu() : null"
           [class.disabled]="!hasUserManagementAccess()"
           [ngClass]="{'tooltip-enabled': !hasUserManagementAccess()}">
          <i class="material-icons card-icon">group_add</i>
          <div class="card-content">
            <h4>User Management</h4>
            <p>Manage user permissions and settings</p>
          </div>
        </a>
      </div>
      <a *ngIf="hasServicePermission('Quotes')"
         class="commercial-offers-link"
         routerLink="/user/quotes"
         (click)="closeMenu()">
        <i class="material-icons">description</i>
        <div class="link-content">
          <span>Quotes</span>
          <small>Create and manage quotes</small>
        </div>
      </a>
    </div>

    <div class="section">
      <h3>Recent Visits</h3>
      <div class="recent-visits">
        <ng-container *ngIf="recentVisits.length > 0">
          <a
            *ngFor="let visit of recentVisits"
            class="recent-item"
            [routerLink]="[visit.path]"
            (click)="closeMenu()"
          >
            <i class="material-icons">{{visit.icon}}</i>
            <span>{{visit.name}}</span>
          </a>
        </ng-container>
        <div *ngIf="recentVisits.length === 0" class="recent-item no-visits">
          <i class="material-icons">info</i>
          <span>No recent visits</span>
        </div>
      </div>
    </div>

    <div class="section">
      <h3>Base Knowledge</h3>
      <a class="documentation-link" href="/documentation" (click)="closeMenu()">
        <i class="material-icons">menu_book</i>
        <div class="link-content">
          <span>Documentation</span>
          <small>User guides and tutorials</small>
        </div>
      </a>
    </div>

    <div class="section menu-footer">
      <div class="footer-links">
        <a class="footer-link contact-link" routerLink="/contact-us" (click)="closeMenu()">
          <i class="material-icons">contact_support</i>
          <span>Contact Us</span>
        </a>
        <button class="footer-link logout-link" (click)="logoutUser()">
          <i class="material-icons">logout</i>
          <span>Log Out</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isLoggedIn && isOpen" class="menu-overlay" (click)="closeMenu()"></div>
